import React from 'react'
import AboutLanding from '../components/AboutLanding'
import EduExp from '../components/EduExp'
import Header from '../components/Header'
import Services from '../components/Services'

export default function About() {
  return (
    <div>
        <Header />
        <div className='container py-5'>
            <AboutLanding />
            <Services />
            <EduExp />
        </div>
    </div>
  )
}
